import React, {useEffect} from 'react'
import {Loading} from 'components/form';
import {useGallery} from 'store/gallery'
import {Item} from './'

export default function Gallery(props) {

   const {getList, loading, list, dispatch, current_page, last_page, per_page} = useGallery();
   useEffect(() => {
      if (!list) {
         dispatch(getList());
      }
   }, [])

   return (
      <>
         <div style={{maxHeight: "80vh"}}
              className="w-5/6 flex flex-wrap content-start justify-start items-start overflow-y-auto"
              onClick={() => props.select(null)}>
            {loading ? <Loading/> : list && list.length > 0 && list.map((item, index) => {
               if (((index + 1) % per_page) == 0 && current_page > 1) {
                  return (<>
                     <Item key={item.id} select={props.select} item={item}
                           selected={props.selectedItem === item}/>
                     <h2 style={{lineHeight: '0.1em'}}
                         className="my-5 w-full flex justify-center text--violet-600 border-b-2 border-violet-100 font-bold">
                        <span className="bg-white  mb-5 px-5">صفحه:{((index + 1) / per_page) + 1}</span>
                     </h2>
                  </>);
               } else {
                  return (<>
                     <Item key={item.id} select={props.select} item={item}
                           selected={props.selectedItem === item}/>
                  </>)
               }

            })}
            {!loading && current_page < last_page && <div className="w-full flex justify-center p-1 my-2 h-12 ">
               <button onClick={() => {
                  dispatch(getList(undefined, undefined, current_page + 1))
               }} className="w-20 text-violet-600 text-bold rounded">بیشتر
               </button>
            </div>}
         </div>
      </>
   );
}
